export default () => ({
  loading: false,
  filters: {},
  chartData: null,
});
